import _typeof from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _defineProperty from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require('intersection-observer'); // polyfill
var Exposure = /*#__PURE__*/function () {
  function Exposure(_ref) {
    var _this = this;
    var callback = _ref.callback,
      _ref$once = _ref.once,
      once = _ref$once === void 0 ? false : _ref$once,
      _ref$option = _ref.option,
      option = _ref$option === void 0 ? {} : _ref$option;
    _classCallCheck(this, Exposure);
    var DEFAULT_OPTION = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    option = _objectSpread(_objectSpread({}, DEFAULT_OPTION), option);
    if (!callback || typeof callback !== 'function') {
      throw new Error('need callback or selector param');
      return;
    }
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (item) {
        if (item.intersectionRatio > 0) {
          if (item.target) {
            callback(item.target, item);
            if (once) _this.intersectionObserver.unobserve(item.target);
          }
        }
      });
    }, option);
  }
  _createClass(Exposure, [{
    key: "observe",
    value: function observe(selector, ignoreExposured) {
      var _this2 = this;
      if (!this.intersectionObserver || !selector) {
        return;
      }
      var nodes = [];
      if (this.isDOM(selector)) {
        // dom节点
        nodes = [selector];
      } else {
        // 选择器
        nodes = document.querySelectorAll(selector);
      }
      if (!nodes.length) {
        return;
      }
      nodes.forEach(function (node) {
        if (!ignoreExposured && node.__wg__tracker__exposured__) {
          return;
        }
        node.__wg__tracker__exposured__ = true;
        // 开始观察
        _this2.intersectionObserver.observe(node);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (!this.intersectionObserver) {
        return;
      }
      this.intersectionObserver.disconnect();
    }
  }, {
    key: "isDOM",
    value: function isDOM(obj) {
      if (!obj) {
        return false;
      }
      if ((typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object') {
        return obj instanceof HTMLElement;
      }
      if (_typeof(obj) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string') {
        return true;
      }
      return false;
    }
  }]);
  return Exposure;
}();
export default Exposure;